export default {"src":"/_next/static/media/app.70b85287.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};